// externals
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// libraries
import { Box } from '@interstate/components/Box';
import { Bars3Icon } from '@interstate/components/Icons/Bars3Icon';
import { Tooltip } from '@interstate/components/Tooltip';
import {
    hideRecentDeals,
    isRecentDealsShown as selectIsRecentDealsShown,
    showRecentDeals
} from '@makemydeal/dr-activities-recent-deals';

// styles
import { recentDealsButtonStyles } from './RecentDealsButton.styles';

const RECENT_DEALS_TOOLTIP = 'Recent deals';

export const RecentDealsButton = () => {
    const dispatch = useDispatch();
    const isRecentDealsShown = useSelector(selectIsRecentDealsShown);

    const handleToggleRecentDeals = useCallback(() => {
        dispatch(isRecentDealsShown ? hideRecentDeals() : showRecentDeals());
    }, [dispatch, isRecentDealsShown]);

    return (
        <Tooltip position="bottom" size="small" toolTipContent={RECENT_DEALS_TOOLTIP}>
            <Box data-testid="recent-deals-trigger-btn" onClick={handleToggleRecentDeals} sx={recentDealsButtonStyles}>
                <Bars3Icon />
            </Box>
        </Tooltip>
    );
};
